import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Colors } from '../../../../../utils/resources/colors';

export interface CallerSettingsCSSStyle extends UIComponentCSSStyle
{
    getCloseButtonDivCSSStyle():object;
}

export class CallerSettingsCSSStyleImpl extends UIComponentCSSStyleImpl implements CallerSettingsCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:'100%',
            // height: "60px",
            paddingBottom: "10px",
           
            // backgroundColor:"#999999",
            // opacity:'0.1'
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginLeft: "170px",
            marginRight: "170px",
            marginTop: "72px",
            marginBottom: "72px",
        };
    }

    getCloseButtonDivCSSStyle():object
    {
        return{
            float:"right", marginTop:'5px', marginRight:"5px",backgroundColor:'#F4F4F4',display:'flex'
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/callersettings/callersettingscss.tsx